import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Error404 from '../Pages/Error404';
import ProtectedRoute from '../component/ProtectedRoute';

import {
  Login,
  Callback,
  Base
} from "../Pages/IS";

const IS = () => (
  <Routes>
    <Route path="/*" element={<Error404 />} />
    <Route path="/" element={<Login />} />
    <Route path="/callback" element={<Callback />} />
    <Route path="/v" element={<ProtectedRoute element={<Base />} role={27} />} />
  </Routes>
);

export default IS;

